module.exports = __webpack_public_path__ + "static/DY2-dd72cf4118608e156a81d46f5b177827.jpg";